import api from "../services/api";

export const updateBusinessDetails = async (formData) => {
  return api.post("/api/business-details/update", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const checkProfileCompletion = async () => {
  return api.get("/api/business-details/check-completion");
};

export const getBusinessDetails = async () => {
  return api.get("/api/business-details/get");
};

